{
    "tk": {
        "Yes": "Hawa",
        "No": "Ýok",
        "Cancel": "Ýatyr",
        "Close": "Ýap",
        "Clear": "Arassala",
        "Done": "Taýyn",
        "Loading": "Ýüklenilýär...",
        "Select": "Saýla...",
        "Search": "Gözle",
        "Back": "Yza",
        "OK": "OK",
        "dxCollectionWidget-noDataText": "Maglumat ýok",
        "dxList-pullingDownText": "Täzelemek üçin aşak çek...",
        "dxList-pulledDownText": "Täzelemek üçin goýberiň...",
        "dxList-refreshingText": "Täzelenýär...",
        "dxList-pageLoadingText": "Ýüklenilýär...",
        "dxList-nextButtonText": "Köpräk",
        "dxList-selectAll": "Hemmesini saýla",
        "dxDataGrid-noDataText": "Maglumat ýok"
    }
}
